
import React, { useState } from "react";
import { useEffect } from "react";
import './styles/panel.css';

function Panel({frameToPanel,toFrame}) {


    // console.log("In panel: "+frameToPanel)
    const [bool, setBool] = useState(frameToPanel);
    useEffect (()=>{
        setBool(frameToPanel)
    })
    
    // const [blinks, setBlinks] = useState(frameToPanel);
    // useEffect (()=>{
    //     setBool(frameToPanel)
    // })

    const [blinkC, setBlinkC] = useState();
    const [blinkV, setBlinkV] = useState();
    const [blinkS, setBlinkS] = useState();

        return(
            <div className="panelContainer">                
				<button style={{animationName:blinkC}} className="guessConst" onClick={() => {toFrame('C');}} disabled={bool} >
                    <h1 className="panelText">Guess A Consonant</h1>
                </button>
                <button style={{animationName:blinkV}} className="guessVowel" onClick={() => {toFrame('V');}} disabled={bool}>
                    <h1 className="panelText">Buy A Vowel</h1>
                </button>
				<button style={{animationName:blinkS}} className="solve" onClick={() => {toFrame('S');}} disabled={bool}>
                    <h1 className="panelText">Slove The Puzzle</h1>
                </button>
			</div>
        );
}

export default Panel